import {createSlice} from "@reduxjs/toolkit";
import {compileString} from "sass";
import {PURGE} from "redux-persist";

const initialState = {
  isAuthenticated: false,
  idToken: null,
  refreshToken: null,
  sessionToken: null,
  loading: false,
  error: false,
  message: "",
  userId: null,
  rememberMe: false,
};

const handleFailure = (state, action) => {
  state.isAuthenticated = false;
  state.idToken = null;
  state.refreshToken = null;
  state.sessionToken = null;
  state.loading = false;
  state.error = true;
  state.userId = null;
  state.isProfileComplete = false;
  // state.message = action?.payload?.response?.data?.detail
  //   ? action?.payload?.response?.data?.detail
  //   : action?.payload?.response?.data?.non_field_errors[0]
  //   ? action.payload.response.data.non_field_errors[0]
  //   : "An error occurred.";
};
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authenticate: (state, action) => {
      // const payload = action.payload;
      state.loading = true;
      state.error = false;
    },
    setAuthenticationSuccess: (state, action) => {
      state.error = false;
      state.message = "";
      state.isAuthenticated = true;
      state.idToken = action.payload.data.idToken;
      state.refreshToken = action.payload.data.refreshToken;
      state.sessionToken = action.payload.data?.sessionToken || null;
      state.loading = false;
      state.userId = action.payload?.data?.id;
      state.rememberMe = action.payload.rememberMe || false;
    },
    setIsProfilePopupVisible: (state, action) => {
      state.isProfileComplete = action.payload;
    },
    setAuthenticationFailure: (state, action) => {
      handleFailure(state, action);
    },
    deAuthenticate: (state) => {
      state.isAuthenticated = false;
      state.idToken = null;
      state.refreshToken = null;
      state.sessionToken = null;
      state.userId = null;
      state.rememberMe = false;
    },
    updateToken: (state, action) => {
      state.idToken = action.payload.idToken;
      state.refreshToken = action.payload.refreshToken;
      if (action.payload.sessionToken) {
        state.sessionToken = action.payload.sessionToken;
      }
    },
    setAuthenticationStatus: (state, action) => {
      if (!action.payload === false) {
        state.isAuthenticated = true;
        state.idToken = action.payload.data.idToken;
        state.refreshToken = action.payload.data.refreshToken;
        state.sessionToken = action.payload.data?.sessionToken || null;
      } else {
        state.isAuthenticated = action.payload;
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(PURGE, () => {
      return initialState;
    });
  },
});

export const {authenticate, deAuthenticate, setAuthenticationStatus, setIsProfilePopupVisible, setAuthenticationSuccess, setAuthenticationFailure, updateToken} = authSlice.actions;
export default authSlice.reducer;
